// IAA internet (live online) and proxy bid fee (effective Nov 4, 2024).
export const IAAIInternetBidFeeCalculator = (amount, type = 'live-bid') => {
  const proxy = type === 'proxy-bid';
  if (amount <= 99.99) return 0;
  if (amount <= 499.99) return proxy ? 40.00 : 50.00;
  if (amount <= 999.99) return proxy ? 55.00 : 65.00;
  if (amount <= 1499.99) return proxy ? 75.00 : 85.00;
  if (amount <= 1999.99) return proxy ? 85.00 : 95.00;
  if (amount <= 3999.99) return proxy ? 100.00 : 110.00;
  if (amount <= 5999.99) return proxy ? 110.00 : 125.00;
  if (amount <= 7999.99) return proxy ? 125.00 : 145.00;
  return proxy ? 140.00 : 160.00;
};
